import React from 'react'
import Paper from '@material-ui/core/Paper'

export default (props) => {
	const { style } = props
	return (
		<Paper
			{...props}
			style={style ? { borderRadius: 20, ...style } : { borderRadius: 20 }}
		/>
	)
}
